import type { FC, ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

import { RadioContainer, RadioLabel } from './styled';

interface IRadio {
    onSelect: (value?: string) => void;
    value: string | number;
    label: string | ReactElement;
    name: string;
    checked?: boolean;
    disabled?: boolean;
}

export const Radio: FC<IRadio> = ({
    checked,
    disabled,
    value,
    label,
    onSelect,
    name,
}) => {
    const { register } = useFormContext();
    const onRadioSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value: string = event.target.value;

        onSelect(value);
    };

    return (
        <RadioContainer>
            <RadioLabel disabled={disabled}>
                <input
                    {...register(name)}
                    onChange={onRadioSelect}
                    type="radio"
                    name={name}
                    disabled={disabled}
                    value={value}
                    checked={checked}
                />{' '}
                {label}
            </RadioLabel>
        </RadioContainer>
    );
};

Radio.defaultProps = {
    disabled: false,
    checked: undefined,
};
